import { message } from "antd";
import { useAppSelector } from "features/common/hooks/useReduxHooks";
import { request } from "libs/axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { gamesTypes } from "../types/gamesTypes";

export interface mutationInterface {
  data: FormData;
  id: null | number;
  token: string | null;
}
const mutationFunction = async ({ id, data, token }: mutationInterface) => {
  data.append("_method", "PUT");
  return request({
    url: `/game-results/${id}`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data,
  });
};

export const useUpdateCodeCell = (id: number | null) => {
  const { currAppToken } = useAppSelector((state) => state.appsAuth);

  return useMutation(
    "CodeCell/Update",
    (data: FormData) => {
      return mutationFunction({ id, data, token: currAppToken });
    },
    {
      onSuccess: async (response) => {
        message.success(response.data.message);
      },
    }
  );
};
